module.exports = "https://s91588.cdn.ngenix.net/home-frontend/_next/static/images/osago-desktop-50004345f8d1fe6e7d8b14d6ef69f797.png.webp";